/**
 * Tiny shared service for B2B contracts — keeps the UI components focused
 * on rendering. All requests share the global axios `api` instance so they
 * automatically attach the auth bearer + httpOnly cookie.
 */
import api from "./api";

export const STATUS = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  ACTIVE: "active",
  REJECTED: "rejected",
  DEACTIVATED: "deactivated",
  EXPIRED: "expired",
};

export const STATUS_META = {
  [STATUS.DRAFT]:        { label: "Draft",         color: "bg-slate-100 text-slate-700" },
  [STATUS.SUBMITTED]:    { label: "Submitted",     color: "bg-blue-100 text-blue-700" },
  [STATUS.UNDER_REVIEW]: { label: "Under review",  color: "bg-amber-100 text-amber-700" },
  [STATUS.APPROVED]:     { label: "Approved",      color: "bg-emerald-100 text-emerald-700" },
  [STATUS.ACTIVE]:       { label: "Active",        color: "bg-emerald-600 text-white" },
  [STATUS.REJECTED]:     { label: "Rejected",      color: "bg-rose-100 text-rose-700" },
  [STATUS.DEACTIVATED]:  { label: "Deactivated",   color: "bg-slate-200 text-slate-600" },
  [STATUS.EXPIRED]:      { label: "Expired",       color: "bg-slate-200 text-slate-500" },
};

export async function listContracts(params = {}) {
  const { data } = await api.get("/b2b/contracts", { params });
  return data;
}

export async function getContract(id) {
  const { data } = await api.get(`/b2b/contracts/${id}`);
  return data;
}

export async function createDraft(payload) {
  const { data } = await api.post("/b2b/contracts", payload);
  return data;
}

export async function patchDraft(id, payload) {
  const { data } = await api.patch(`/b2b/contracts/${id}`, payload);
  return data;
}

export async function transition(id, action, body = {}) {
  const { data } = await api.post(`/b2b/contracts/${id}/${action}`, body);
  return data;
}

export async function quote(payload) {
  const { data } = await api.post("/b2b/contracts/quote", payload);
  return data;
}

export async function myActive() {
  const { data } = await api.get("/b2b/contracts/my-active");
  return data;
}

export function emptyRateCard() {
  return {
    scope: "national",
    service_type: "standard",
    origin_hub_id: "",
    destination_hub_id: "",
    slabs: [
      { up_to_kg: 1, base_inr: 60, per_extra_kg_inr: 0 },
      { up_to_kg: 5, base_inr: 90, per_extra_kg_inr: 12 },
    ],
  };
}
